import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util, { getQRCodeDynamicUrl, getQRCodeImgSrc, getLandingPageDynamicShortUrl, getOMDashboardLink, getLPDashboardLink, toLogIn } from '../util';
import cached from "../canvas/cached";
import locationService from "../service/locationService";
import designService from "../service/designService";
import designDomain from "../domain/designDomain";
import store from "../store";
import constants from "../constants";
import linkRef from "linkref";
import $ from "jquery";
import { addComponent, VIEWPORT_CENTER } from "../canvas/component";
import Renderer from "../canvas/renderer";
import qrCodeService from '../service/qrCodeService';
import Spinner2 from '../component/Spinner2';
import { createPortal } from "preact/compat";
import CloudUploadOutlined from "@ant-design/icons/lib/icons/CloudUploadOutlined";
import axios from 'axios';
import imageService from "../service/imageService";
import newOOService from '../service/newOOService';
import ooService from '../service/ooService';

export default @connect(reduce, actions)
class QRCodesModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // locations: [],
      // locationId: props.locationId || cached.selectedLocationId || -1,
      designId: '',
      designs: [],
      design: '',
      isLoading: false,
      mode: props.mode,
      qrCode: props.qrCode,
      qrCodes: props.qrCodes,
      qrCodeName: '',
      qrCodeType: props.qrCode ? props.qrCode.type : props.qrCodeType,
      customUrl: props.customUrl,
      omLocationData: props.omLocationData,
      error: '',
      landingPages: [],
      landingPageId: props.landingPageId || '',
      landingPage: '',
      landingPagePublished: '',
      pdfFile: 'Upload a PDF (up to 15MB)',
      qrCodeTypes: [
        { key: 'saved-design', label: 'Saved Design' },
        { key: 'online-menu', label: 'Online Menu' },
        { key: 'landing-page', label: 'Link Page' },
        { key: 'custom-url', label: 'Website' },
        { key: 'pdf', label: 'PDF' }
      ]
    }
  }

  // populateLocations() {
  //   this.setState({ isLoading: true });
  //   locationService.getMemberLocations().then(resp => {
  //     const locations = resp.data || [];
  //     const locationId = cached.selectedLocationId || (locations.length > 0 ? locations[0].locationId : -1);
  //     this.setState({ locations, locationId });
  //     this.populateDesigns(locationId);
  //   });
  // }

  populateDesigns() {
    this.setState({ isLoading: true });

    designService.updateDesignHtml({
      id: this.props.designId,
      html: Renderer.getPagesContent(),
      hasVideo: store.getState().hasVideo
    }).then(() => {
      designService.getDesignsForLocation(this.getLocationId()).then(resp => {
        const designs = (resp.data.list || []).map(it => new designDomain.LightDesign(it));
        designs.forEach(it => it.selected = it.id === this.state.designId);
        this.setState({ designs, isLoading: false });
      });
    });
  }

  onDesignClick(design, ev) {
    const designs = [...this.state.designs];
    designs.forEach(it => it.selected = it.id === design.id);
    this.setState({ design, designId: design.id });
    if (ev.detail > 1) {
      this.getQRCode();
    }
  }

  populateLandingPages() {
    this.setState({ isLoading: true });

    qrCodeService.getLocationLandingPages(this.getLocationId(), false).then(resp => {
      let landingPages = (resp.data || []);
      let mode = '';

      if (landingPages.length == 1 && !landingPages[0].published) {
        this.setState({ landingPageId: landingPages[0].id });
        mode = 'landing-page-publish';
      } else if (landingPages.length > 0) {
        landingPages = landingPages.sort((a, b) => {
          return (b.draftLastUpdated - a.draftLastUpdated);
        });
        
        this.setState({ landingPages});
        mode = 'landing-page';
      } else {
        mode = 'landing-page-new';
      }

      this.setState({ 
        isLoading: false,
        mode: mode,
        qrCodeType: 'landing-page'
      });
    });
  }

  onLandingPageClick(landingPage, ev) {
    const landingPages = [...this.state.landingPages];
    landingPages.forEach(it => it.selected = it.id === landingPage.id);
    this.setState({ landingPage, landingPageId: landingPage.id, landingPagePublished: landingPage.published });
    if (ev.detail > 1) {
      this.getQRCode();
    }
  }

  onClose(bypassLoad) {
    if (this.refs && this.refs.searchField) this.refs.searchField.value = '';
    this.props.onModalClose(bypassLoad);
  }

  getQRCode() {
    if (!!this.state.customUrl) {
      this.storeQRCode();
    } else if (!!this.state.designId) {
      this.storeQRCode();
    } else if (!!this.state.landingPageId) {
      if (!this.state.landingPagePublished) {
        this.setState({ mode: 'landing-page-publish' });
      } else {
        this.storeQRCode();
      }
    } else if (this.state.mode === 'online-menu') {
      this.storeQRCode();
    } else {
      this.setState({ isLoading: false });
    }
  }

  storeQRCode() {
    let link = '';

    switch (this.state.mode) {
      case 'custom-url':
      case 'online-ordering':
      case 'facebook':
      case 'saved-design-edit':
      case 'pdf':
        link = this.state.customUrl;
        break;
      case 'saved-design':
        link = this.state.designId;
        break;
      case 'landing-page':
        link = this.state.landingPageId;
        break;
      case 'online-menu':
        link = window.location.origin + '/places/qr/' + this.getLocationId();
        break;
    }

    if (link.indexOf(' ') > -1) {
      this.setState({ error: 'Please enter a valid URL.' });
      return;
    }

    // check if entered name is valid
    let inputName = this.state.qrCodeName;
    if (inputName && this.state.mode != 'landing-page' && this.state.mode != 'pdf' && this.state.mode != 'saved-design') {
      const _this = this;
      let nameAlreadyExists = false;

      this.state.qrCodes.forEach(code => {
        if (_this.state.qrCode) {
          if (code.id !== _this.state.qrCode.id && code.name === inputName) {
            nameAlreadyExists = true;
          }
        }
      });

      if (nameAlreadyExists) {
        $('.name-error').html('<span>You already have a QR code called "' + inputName + '". <br/>Please choose another name.</span>');
        return;
      }
    }
    $('.name-error').html("<span></span>");
    this.setState({ error: '' });

    this.setState({ isLoading: true });

    let qrCodeDto = {};
    if (this.state.qrCode) {
      // if editing code
      // let dtoMode = this.state.mode === 'saved-design-edit' ? 'saved-design' : this.state.mode;
      let dtoMode = this.state.qrCodeType;

      if (this.state.qrCodeName === '') {
        // no name
        qrCodeDto = {
          id: this.state.qrCode.id,
          type: dtoMode,
          url: link,
          locationId: this.props.locationId
        }
      } else {
        // has name
        qrCodeDto = {
          id: this.state.qrCode.id,
          type: dtoMode,
          url: link,
          name: this.state.qrCodeName,
          locationId: this.props.locationId
        }
      }

      qrCodeService.updateQRCode(qrCodeDto).then((resp) => {
        this.setState({ isLoading: false });
        this.props.onModalClose();

        if (link === this.props.designId) {
          window.data.design.qrCodeId = resp.data.id;
        } else {
          window.data.design.qrCodeId = '';
        }
      });
    } else {
      // creating new code
      if (this.state.qrCodeName === '') {
        // no name
        qrCodeDto = {
          type: this.state.mode,
          url: link,
          memberId: this.props.memberId,
          locationId: this.props.locationId
        }
      } else {
        // has name
        qrCodeDto = {
          type: this.state.mode,
          url: link,
          memberId: this.props.memberId,
          locationId: this.props.locationId,
          name: this.state.qrCodeName
        }
      }

      qrCodeService.createQRCode(qrCodeDto).then((resp) => {
        const qrCode = resp.data;
        this.setState({ qrCode, isLoading: false });
        if (store.getState().isMobileVersion) {
          this.props.onModalClose(false, false);
        } else {
          this.props.onModalClose();
        }
        this.props.openCreateQRDesignModal();

        if (link === this.props.designId) {
          window.data.design.qrCodeId = qrCode.id;
        }
      });
    }
  }

  showAuthModal(view) {
    this.props.onFullClose();
    toLogIn();
  }

  getInitNameValue() {
    if (this.state.qrCode && this.state.qrCode.name) {
      this.setState({ qrCodeName: this.state.qrCode.name });
      return this.state.qrCode.name;
    }
    if (this.state.mode === 'online-menu') {
      return this.getOMQRName();
    }
    return '';
  }

  getOMQRName() {
    // since we don't want duplicate code names, each OM code must have a different one
    // determine how many om codes already exist
    let toName = 'Online Menus for ' + this.state.omLocationData.location.name;
    let existCodes = this.state.qrCodes.filter(function (code) {
      if (code.name) {
        return code.name.startsWith(toName);
      }
    }).length;
    if (existCodes > 0) {
      toName += ' (' + existCodes.toString() + ')';
    }
    if (!this.state.qrCodeName) {
      this.setState({ qrCodeName: toName });
    }
    return toName;
  }

  onSearchKeyUp(ev) {
    const value = ev.target.value.toLowerCase();
    const designs = this.state.designs;

    designs.forEach(it => it.visible = it.name.toLowerCase().indexOf(value) > -1);
    this.setState({ designs: [...designs] });
  }

  updateCustomUrl(ev) {
    this.setState({ customUrl: ev.target.value });
  }

  updateQRCodeName(ev) {
    this.setState({ qrCodeName: ev.target.value });
  }

  toSavedDesigns() {
    // called when editing design link for saved design code
    this.setState({ mode: 'saved-design' });
    // this.populateLocations();
    this.populateDesigns();
  }

  uploadQRCodePdf(ev) {
    if (!this.state.isLoading) {
      const files = ev.target.files;
      const formData = new FormData();
      if (!files.length) return;

      const fileType = files[0].type.toLowerCase();

      if (fileType !== 'application/pdf' || !util.validateFileSize(files, 15)) {
        ev.target.value = '';
        this.setState({ error: 'Please select a PDF file with a maximum size of 15MB' });
        return;
      }

      this.setState({ error: '' });
      this.setState({ isLoading: true });

      var fileName = $("#pdf-qr-code-input").val();

      this.setState({ pdfFile: fileName.replace(/C:\\fakepath\\/i, '') });

      if (!$('.qr-name-input').val()) {
        var name = fileName.replace(/C:\\fakepath\\/i, '').replace('.pdf', '');
        this.setState({ qrCodeName: name })
        $('.qr-name-input').val(name);
      };

      const _this = this;

      const {memberId} = store.getState();

      formData.append("pdf", files[0], files[0].name);

      imageService.uploadQRPdf(memberId, formData).then(resp => {
        if (resp) {
          const customUrl = "https://timber.mhmcdn.com/" + resp.data;
          _this.setState({ customUrl });
        }

        _this.setState({ isLoading: false });
      })
    }
    ev.target.value = '';
  }

  componentDidMount() {
    if (this.props.mode === 'saved-design') {
      this.populateDesigns();
    }

    if (this.props.mode === 'landing-page') {
      this.populateLandingPages();
    }

    if ($('.qr-name-input')) {
      $('.qr-name-input').val(this.getInitNameValue());
    }
  }

  exitToLink(linkPath) {
    try {
      if (!this.props.isLogged) {
        toLogIn();
        return;
      }

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      $('.modal-back').show();

      if (this.props.hasChanges) {
        designService.updateDesign({
          id: this.props.designId,
          html: Renderer.getPagesContent(),
          name: this.props.designName,
          lastSavedTag: this.props.lastSavedTag
        }).then(() => {
          this.props.setIsSaved(true)
          this.props.setIsSaving(false)
          this.props.setShowExitWarning(false)

          window.location = linkPath;
        });
      } else {
        window.location = linkPath;
      }
    } catch (err) {
      console.log(err.stack);
    }
  }

  getLocationId() {
    return store.getState().locationId || window.data.design.locationId;
  }

  // getOnlineMenu() {
  //   return axios.get(`/app/online//location/stats/${store.getState().locationId || window.data.design.locationId}`);
  // }

  onChangeQRCodeType(ev) {
    const type = ev.target.value;
    const mode = type;

    if (type === 'saved-design') {
      this.populateDesigns();
    }

    if (type === 'landing-page') {
      this.populateLandingPages();
    } else if (type == 'online-menu') {
      const _this = this;
      this.setState({ isLoading: true, qrCodeType: type });

      // this.getOnlineMenu().then(function(resp) {
      ooService.getStatusForMember(this.props.memberId).then(function(resp) {
        console.log(resp);
        let data = JSON.parse(resp.data.data);
        let mode = '';
        
        if (data.location && data.published) {
            _this.setState({ omLocationData: data });
            mode = 'online-menu';
        } else {
            if (data.location && data.location.menuCount > 0) {
              mode = 'online-menu-publish';
            } else {
              mode = 'online-menu-new';
            }
        }

        _this.setState({ 
          qrCodeType: type,
          mode: mode,
          isLoading: false
        });
      })
    } else {
      this.setState({ 
        qrCodeType: type,
        mode: mode,
      });
    }
  }

  render(props, state) {

    let headerContent = '';
    let headerText = '';
      // <h2>
      //   <img src="https://musthavemenus.com/imageservice/images/img/13/icons/qr-code-icon.png" className="qr-code-icon" style="width: 25px; height: 25px; vertical-align: bottom" /> QR Codes
      // </h2>
    let namePlaceholder = 'Name your QR Code';
    let content = '';
    let modalSize = '';
    let footerContent =
      <footer className={'create-qr-footer ' + (props.isLogged ? '' : 'hidden')}>
        <a className={'button primary' + ((state.design || state.customUrl || state.qrCode || state.landingPage || state.mode === 'online-menu') ? '' : ' disabled')} onClick={() => this.getQRCode()}>
          <span className={(state.qrCode ? 'hidden' : '')}>Get QR Code</span>
          <span className={(state.qrCode ? '' : 'hidden')}>Done</span>
        </a>
      </footer>

    let alertModal = state.mode === 'online-menu-publish' || state.mode === 'landing-page-publish';

    const selectQRCodeType = 
      <select onChange={this.onChangeQRCodeType.bind(this)} value={state.qrCodeType}>
        {state.qrCodeTypes.map(type => (<option value={type.key}>{type.label}</option>))}
      </select>

    switch (state.mode) {
      case 'rename':
        modalSize = 'modal-xsmall';
        headerContent = <h2>Rename</h2>;
        
        content =
          <div className="align-left">
            <input className="qr-name-input" placeholder={namePlaceholder} onKeyUp={this.updateQRCodeName.bind(this)} />
            <p className="error name-error"></p>
            <p className="error">{state.error}</p>
          </div>;
        
        footerContent = 
          <footer className={'create-qr-footer ' + (props.isLogged ? '' : 'hidden')}>
            {/* <a className={'button'}  onClick={() => this.onClose(true)}>Cancel</a> */}
            <a className={'button primary'} onClick={() => this.storeQRCode()}>Rename</a>
          </footer>
        break;

      case 'custom-url':
      case 'facebook':
      case 'online-ordering':
        let placeholder = '';
        modalSize = 'modal-small';

        if (state.mode === 'facebook') {
          headerContent = <p>Link to a Facebook page.</p>;
          placeholder = 'https://www.facebook.com/your-page/';
        } else if (state.mode === 'online-ordering') {
          headerContent = <p>Link to your Online Ordering site.</p>;
          placeholder = 'https://www.your-online-ordering.com';
        } else {
          headerContent = <p>Link to any URL</p>;
          placeholder = 'https://www.mywebsite.com';
        }

        content =
          <div className="align-left">
            {state.qrCode && state.qrCode.id && selectQRCodeType}
            {/* <input className="qr-name-input" placeholder={namePlaceholder} onKeyUp={this.updateQRCodeName.bind(this)} /> */}
            
            <p className="error name-error"></p>

            <span className="qr-name-label">URL:</span>
            <input className="qr-link-input" placeholder={placeholder} value={state.customUrl} onChange={this.updateCustomUrl.bind(this)} />
            <p className="error">{state.error}</p>
          </div>;
        break;

      case 'saved-design-edit':
        // show modal when editing a saved design code
        if (!state.customUrl) {
          this.setState({ customUrl: state.qrCode.url });
        }
        if (!state.designId) {
          this.setState({ designId: state.qrCode.id });
        }
        modalSize = 'modal-small';
        headerContent = <p>Edit your QR code.</p>
        content =
          <div className="align-left">
            {state.qrCode && state.qrCode.id && selectQRCodeType}
            {/* <input className="qr-name-input" placeholder={namePlaceholder} onKeyUp={this.updateQRCodeName.bind(this)} /> */}
            <p className="error name-error"></p>
            <span className="qr-name-label edit-button-flex">Saved Design</span>
            <span className="qr-link-name">{state.qrCode.savedDesignName}</span>
            <a className={'button edit-link-button'} onClick={() => this.toSavedDesigns()}>Change Design</a>
            <p className="error">{state.error}</p>
          </div>
        break;

      case 'saved-design':
        // pick design for code
        // let locationSelect = null;
        // if (props.isLogged && state.locations.length > 1) {
        //   const options = state.locations.map(location => (
        //     <option value={location.locationId}>{location.restaurantName}</option>
        //   ));
        //   locationSelect = (
        //     <select onChange={this.onLocationChange.bind(this)} value={state.locationId}>{options}</select>
        //   )
        // }

        headerContent =
          <div>
            <p>Select a design to link to</p>
            <div style="display: flex; padding: 0 2rem;">
              {/* {locationSelect} */}
              {state.qrCode && state.qrCode.id && selectQRCodeType}
              <div className="search">
                <input type="text" placeholder="Search" onKeyUp={this.onSearchKeyUp.bind(this)} ref={linkRef(this, 'searchField')} />
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-search"} />
                </svg>
              </div>
            </div>
          </div>;

        content =
          <div className="card">
            <p>This step requires an account</p>
            <footer className="buttons">
              <a className="button" onClick={() => this.showAuthModal('log')}>LOG IN</a>
              <a className="button" onClick={() => this.showAuthModal('reg')}>FREE SIGN UP</a>
            </footer>
          </div>

        if (props.isLogged) {
          content = (<p>Loading...</p>);
          if (!state.isLoading) {
            if (state.designs.length > 0) {
              const cacheBuster = util.UUID.get();

              let options = state.designs.filter(it => it.visible).map(design => (
                <li onClick={(ev) => this.onDesignClick.bind(this)(design, ev)}>
                  <a className={design.selected ? 'sel' : ''}>
                    <img src={`${constants.RENDERER_DOMAIN}/design/thumbnail/${design.id}?width=300&${cacheBuster}`} />
                    <h3>{design.name}</h3>
                  </a>
                </li>
              ));

              if (options.length > 0) {
                content = (<ul className="designs">{options}</ul>);
              } else {
                content = (<p>No designs found.</p>);
              }
            } else {
              content = (<p>No designs found.</p>);
            }
          }
        }
        break;

      case 'online-menu-new':
        // when online menu is not set up, show this modal
        modalSize = 'modal-med';
        headerText = <h2>Online Menu</h2>
        content =
          <div>
            <img src="/imageservice/images/img/13/mymenus/banners/om_banner_d.png" style="width: 100%; margin: 10px 0" />
            <p>You don't have an online menu set up yet! <br /> It's easy to do in just a few minutes.</p>
            <a className='button primary' onClick={() => {
                window.open(getOMDashboardLink(this.getLocationId()), '_blank');
                this.onClose(true);
              }}>
              <span>Create</span>
            </a>
            <a className='maybe-later' onClick={() => this.onClose(true)}>Maybe Later</a>
          </div>
        footerContent = '';
        break;

      case 'online-menu-publish':
        // when online menu is not published, show this modal
        modalSize = 'modal-med';
        headerText = <h2>Your Online Menu needs to be published first</h2>
        headerContent = '';
        content =
            <div style="margin-top: 20px;">
              <a className='btn decline' onClick={() => this.onClose(true)}>Cancel</a>
              <a className='btn primary accept' onClick={() => {
                window.open(getOMDashboardLink(this.getLocationId()), '_blank');
                this.onClose(true);
              }}>
                <span>Publish Online Menu</span>
              </a>
            </div>
        footerContent = '';
        break;

      case 'online-menu':
        // make or edit code for existing online menu
        modalSize = 'modal-small';
        headerContent = <p>Link to your Online Menu</p>;

        content =
          <div className="align-left">
            {state.qrCode && state.qrCode.id && selectQRCodeType}
            {/* <input className="qr-name-input" placeholder={namePlaceholder} onKeyUp={this.updateQRCodeName.bind(this)} /> */}
            <p className="error name-error"></p>
            <span className="qr-name-label edit-button-flex">Online Menu</span>
            <span className="qr-link-name">Online Menus for {state.omLocationData.location.name}</span>
            <a className={'button edit-link-button' + (state.qrCode ? '' : ' hidden')} onClick={() => {
                window.open(getOMDashboardLink(this.getLocationId()), '_blank');
                this.onClose(true);
            }}>
              Edit Menus
            </a>
            <p className="error">{state.error}</p>
          </div>
        break;

      case 'landing-page':
        headerContent =
          <div>
            <p>Select a Link Page to link to</p>
            <div style="padding: 0 2rem;">
            {state.qrCode && state.qrCode.id && selectQRCodeType}
            </div>
          </div>;

        if (props.isLogged) {
          content = (<p>Loading...</p>);
          if (!state.isLoading) {
            if (state.landingPages.length > 0) {
              let options = state.landingPages.map(landingPage => (
                <li onClick={(ev) => this.onLandingPageClick.bind(this)(landingPage, ev)}>
                  <a className={landingPage.selected ? 'sel' : ''}>
                    <iframe src={`${getLandingPageDynamicShortUrl(landingPage.customId || landingPage.id)}?preview=true`} scrolling="no"></iframe>
                    <h3>{landingPage.name}</h3>
                    {!landingPage.published ? <label class="unpublished-badge">UNPUBLISHED</label> : ''}
                  </a>
                </li>
              ));

              if (options.length > 0) {
                content = (<ul className="landing-pages">{options}</ul>);
              } else {
                content = (<p>No landing pages found.</p>);
              }
            } else {
              content = (<p>No landing pages found.</p>);
            }
          }
        }

        break;

      case 'landing-page-new':
        // when no landing pages are created, show this modal
        modalSize = 'modal-med';
        headerText = <h2>Link Page</h2>
        content =
          <div>
            <img src="/imageservice/images/img/13/mymenus/banners/qr_banner_d.png" style="width: 100%; margin: 10px 0" />
            <p>
              It's easy to build a mobile-friendly page to <br />
                showcase your menus, online ordering, social links and more.
            </p>
            <a className='button primary' onClick={() => {
                window.open(getLPDashboardLink(this.getLocationId(), 'new'), '_blank');
                this.onClose(true);
              }}>
              <span>Create</span>
            </a>
            <a className='maybe-later' onClick={() => this.onClose(true)}>Maybe Later</a>
          </div>
        footerContent = '';
        break;

      case 'landing-page-publish':
        // when landing page is not published, show this modal
        modalSize = 'modal-med';
        headerText = <h2>Your Link Page needs to be published first</h2>
        headerContent = '';
        content =
            <div style="margin-top: 20px;">
              <a className='btn decline' onClick={() => this.onClose(true)}>Cancel</a>
              <a className='btn primary accept' onClick={() => {
                window.open(getLPDashboardLink(this.getLocationId(), state.landingPageId), '_blank');
                this.onClose(true);
              }}>
                <span>Publish Link Page</span>
              </a>
            </div>
        footerContent = '';
        break;

      case 'pdf':
        modalSize = 'modal-small';

        headerContent = <p>Link to any PDF</p>;

        content =
          <div>
            {state.qrCode && state.qrCode.id && selectQRCodeType}
            {/* <input className="qr-name-input" placeholder={namePlaceholder} onKeyUp={this.updateQRCodeName.bind(this)} value={state.qrCodeName} /> */}
            <p className="error name-error"></p>

            <div className="pdf-upload-area">
              <span className="label">{state.pdfFile}</span>
              <label for="pdf-qr-code-input"><CloudUploadOutlined /></label>
              <input id="pdf-qr-code-input" name="pdf-qr-code-input" type="file" accept=".pdf" onChange={ this.uploadQRCodePdf.bind(this) } />
            </div>

            <p class="error">{state.error}</p>
          </div>

          footerContent =
            <footer className={'create-qr-footer ' + (props.isLogged ? '' : 'hidden')}>
              <a className={'button primary' + ((state.customUrl) ? '' : ' disabled')} onClick={() => this.getQRCode()}>
                <span className={(state.qrCode ? 'hidden' : '')}>Get QR Code</span>
                <span className={(state.qrCode ? '' : 'hidden')}>Done</span>
              </a>
            </footer>

        break;
    }

    return props.open ? createPortal(<div onClick={this.menuContentModalClick}>
      <div class="modal-back"></div>
      <div className={'modal qr-code-content ' + modalSize + (alertModal ? ' alert' : '')}>
        <div>
          <header className="large">

            <div className="close" onClick={() => this.onClose(true)}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-close"} />
              </svg>
            </div>
            {headerText}
            {headerContent}
          </header>

          {state.isLoading ? <Spinner2 /> :
            <div>
              <div style={'text-align: center;' + (state.mode === 'saved-design' ? ' top: 105px;' : state.mode === 'landing-page' ? ' top: 105px;' : state.mode === 'pdf' ? '' : '')} className='modal-content qr-code-modal'>
                <div className={state.mode === 'saved-design' || state.mode === 'landing-page' ? "scroller bordered" : ''}>
                  {content}
                </div>
              </div>
              {footerContent}
            </div>
          }
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
